const SEPARATOR = "~"; // never produced by base64url, and not percent-encoded in URLs

const toBase64Url = str => {
  const bytes = new TextEncoder().encode(str);
  let binary = "";
  bytes.forEach(b => {
    binary += String.fromCharCode(b);
  });
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

const fromBase64Url = str => {
  try {
    const base64 = str.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } catch (e) {
    return null;
  }
};

// Keep title characters, only make them URL safe
const cleanTitle = (title = "") =>
  encodeURIComponent(
    Array.from(String(title).trim()) // Array.from avoids cutting an emoji in half
      .slice(0, 80)
      .join("")
      .replace(/[\/\\]/g, " ") // slashes would break routing
  );

// id + title -> "Add%20Article~cHJpdi0x"
export const encodeArticleSlug = (id, title) => {
  // "id:" prefix is a simple marker so random strings can be rejected on decode
  const encodedId = toBase64Url(`id:${id}`);
  return `${cleanTitle(title)}${SEPARATOR}${encodedId}`;
};

// "Add%20Article~cHJpdi0x" -> "1"
export const decodeArticleSlug = slug => {
  if (!slug) return null;

  const raw = String(slug);
  const index = raw.lastIndexOf(SEPARATOR); // title may contain "~", the id cannot
  if (index === -1) return null;

  const decoded = fromBase64Url(raw.slice(index + 1));
  if (!decoded || !decoded.startsWith("id:")) return null;

  return decoded.slice(3) || null;
};
let articleNotFound = false;
const notFoundListeners = new Set();

// call this from ArticleDetail
export const setArticleNotFound = value => {
  if (articleNotFound === value) return;
  articleNotFound = value;
  notFoundListeners.forEach(listener => listener(value));
};

// call this from any other component to read the current value
export const getArticleNotFound = () => articleNotFound;

// lets a component re-render when the value changes; returns an unsubscribe fn
export const subscribeArticleNotFound = listener => {
  notFoundListeners.add(listener);
  return () => notFoundListeners.delete(listener);
};
